import PropTypes from 'prop-types';
import { Label, FormHelp } from '@zillow/constellation';
import { int as intParser } from '../../../parsers';
import { int as intFormatter } from '../../../formatters';
import { LabeledInputField } from '../../common';

export const getNumericFieldRegisterProps = errMessage => ({
    validate: v => {
        const parsedVal = intParser(v);
        if (parsedVal === null || parsedVal < 0) {
            return errMessage;
        }
        return true;
    },
    setValueAs: v => intParser(v) || v,
    onBlur: e => {
        const formattedVal = intFormatter(e.target.value);
        if (formattedVal) {
            e.target.value = formattedVal;
        }
    },
});

const NumericField = ({ labelText, helpText, ...restProps }) => (
    <LabeledInputField
        inputMode="numeric"
        pattern="[0-9,.]*"
        aria-label={labelText}
        renderLabel={labelProps => <Label {...labelProps}>{labelText}</Label>}
        description={helpText && <FormHelp>{helpText}</FormHelp>}
        {...restProps}
    />
);

NumericField.propTypes = {
    labelText: PropTypes.string.isRequired,
    helpText: PropTypes.string,
};

export default NumericField;
